import useReveal from '../hooks/useReveal'
import LandingHeader from './landing/LandingHeader'
import Hero from './landing/Hero'
import DrawTeaser from './landing/DrawTeaser'
import HearReading from './landing/HearReading'
import { HowItWorks, SpreadShowcase, Faq, FinalCta, LandingFooter } from './landing/Sections'
import './Public.css'

/**
 * The public landing page. Ordered as a visitor's questions come:
 * what is this (hero), can I try it (draw), how does it work, what can I
 * ask (spreads), what does it sound like (hear), can I trust it (faq),
 * and finally the invitation again.
 */
const Public = () => {
    const revealRef = useReveal()

    return (
        <div className="arcana" ref={revealRef}>
            <LandingHeader />
            <main>
                <Hero />
                <DrawTeaser />
                <HowItWorks />
                <SpreadShowcase />
                <HearReading />
                <Faq />
                <FinalCta />
            </main>
            <LandingFooter />
        </div>
    )
}

export default Public
